// extracted by mini-css-extract-plugin
export default {"cyclingText":"CyclingText_cyclingText__AR7SP","visible":"CyclingText_visible__TZJOg","hidden":"CyclingText_hidden__x8XfE"};